import { Summary } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { SUMMARY_BASE_PATH } from '../constants/summaryBasePath';

export const getSummary = async (
  constructGet: ConstructGet,
  definitionName: string,
  uuid: string,
): Promise<NonPaginatedResponse<Summary> | undefined> =>
  constructGet(`${SUMMARY_BASE_PATH}/${uuid}`, {
    headers: {
      [InceptHeader.DefinitionName]: definitionName,
    },
  });
